module.exports = __webpack_public_path__ + "static/vitamin_k2-75d95164d735821667037302729c23fb.png";